const removeEmpty = o =>
  Object.keys(o).reduce((out, key) => {
    if (o[key] === '') return out
    // convert booleans
    if (['true', 'false'].indexOf(o[key]) > -1)
      return Object.assign(out, { [key]: JSON.parse(o[key]) })
    return Object.assign(out, { [key]: o[key] })
  }, {})

export default removeEmpty
